import styled from 'styled-components';
import { layout, media, remCalc } from 'src/components/base';

export const Block = styled.div`
  column-count: 2;
  h3,
  h4 {
    font-size: ${remCalc(14)};
  }

  ${media.mediumUp`
    column-count: 3;
  `}
`;
export const Category = styled.div`
  display: flex;
  flex-direction: column;
  break-inside: avoid;
  margin-bottom: ${layout.marginBottomSubComponent};
  ${media.mediumDown`
    margin-bottom: ${remCalc((layout.marginBottomSubComponentVal * 2) / 3)}
  `};

  ${media.mediumUp`
    padding: 0 10px;
  `}
`;
